/** @griffel:css-start [d] null **/
.fgx874q{grid-template-columns:minmax(0, 1fr);}
.fanxd30{font-size:13px;}
.f1n95isl{line-height:20px;}
.fdj6btp{font-weight:var(--fontWeightMedium);}
.f19n0e5{color:var(--colorNeutralForeground1);}
.f1ugzwwg{font-size:12px;}
.f104wqfl{line-height:16px;}
.f11d4kpn{color:var(--colorNeutralForeground3);}
.f1hcrxcs{color:var(--colorPaletteRedForeground1);}
/** @griffel:css-end **/